import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Article } from "../../interfaces/Article";
import { slugify } from "../../functions/slugify";
import { useIntl } from "react-intl";

interface BlogPopularProps {
  articles: Article[];
}

const BlogPopular: React.FC<BlogPopularProps> = ({ articles }) => {
  const intl = useIntl();
  const popularPosts = useMemo(() => {
    return [...articles]
      .sort((a, b) => (b.totalViewed || 0) - (a.totalViewed || 0))
      .slice(0, 3);
  }, [articles]);

  if (popularPosts.length === 0) return null;

  const imageUrl = (post: Article) =>
    post.thumbnail && post.thumbnail.length > 0 ? post.thumbnail[0] : "";

  return (
    <div className="popular-articles-widget p-4 text-start">
      <div className="border-1 border-bottom">
        <h5 className="fw-bold mb-3">
          {intl.formatMessage({ id: "BLOG.POPULAR" })}
        </h5>
      </div>
      <div className="row pt-4">
        {popularPosts.map((post) => (
          <div className="col-lg-4 mb-4" key={post.id}>
            <div className="row align-items-center g-3">
              <div className="col-4">
                <Link
                  to={`/blog/${post.id}/${slugify(post.title)}`}
                  className="text-decoration-none group"
                >
                  <div
                    className="position-relative w-100"
                    style={{
                      aspectRatio: "16 / 9",
                      overflow: "hidden",
                      backgroundColor: "#eee",
                      boxShadow:
                        "0 3px 12px -1px rgba(7, 10, 25, 0.2), 0 22px 27px -20px rgba(7, 10, 25, 0.2)",
                    }}
                  >
                    {imageUrl(post) && (
                      <img
                        src={imageUrl(post)}
                        alt={post.title}
                        crossOrigin="anonymous"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          width: "100%",
                          height: "auto",
                          transform: "translate(-50%, -50%)",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    )}
                  </div>
                </Link>
              </div>
              <div className="col-8">
                <Link
                  to={`/blog/${post.id}/${slugify(post.title)}`}
                  className="text-decoration-none group"
                  style={{ display: "block" }}
                >
                  <div className="popular-title mb-1 text-dark fw-bold">
                    {post.title}
                  </div>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPopular;
